<template>
  <el-dialog
    :title="dialogTitle"
    v-model="visibleProxy"
    width="640px"
    :modal-append-to-body="false"
    custom-class="ad-add-crowd-dialog"
    :close-on-click-modal="false"
    @close="handleDialogClose"
  >
    <div class="crowd-dialog-body">
      <el-form ref="formRef" :model="form" label-position="left" label-width="168px" class="crowd-dialog-form">
        <el-form-item>
          <template slot="label">
            <span class="required">*</span> 人群名称
          </template>
          <div class="crowd-field-block">
            <el-input
              v-model="form.name"
              placeholder="最多20个字"
              :maxlength="20"
              clearable
              @blur="validateName"
            />
            <div v-if="isDuplicateName" class="crowd-field-error">人群名称不允许重复</div>
          </div>
        </el-form-item>

        <el-form-item>
          <template slot="label">
            <span class="required">*</span> 人群说明
          </template>
          <el-input
            v-model="form.description"
            placeholder="最多50个字"
            :maxlength="50"
            clearable
          />
        </el-form-item>

        <el-form-item>
          <template slot="label">
            <span class="required">*</span> 是否学校任务跑用户
          </template>
          <div class="crowd-field-block">
            <el-radio-group v-model="form.isSchoolRunUser">
              <el-radio label="yes">是</el-radio>
              <el-radio label="no">否</el-radio>
            </el-radio-group>
            <div class="crowd-hint crowd-hint--red">
              * 学校任务跑用户，在「运营后台-校区管理」中配置
            </div>
          </div>
        </el-form-item>

        <el-form-item>
          <template slot="label">
            <span class="required">*</span> 学期是否开始
          </template>
          <el-radio-group v-model="form.semesterStarted">
            <el-radio label="any">不限</el-radio>
            <el-radio label="yes">是</el-radio>
            <el-radio label="no">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item>
          <template slot="label">
            <span class="required">*</span> 是否有校园跑学期目标
          </template>
          <el-radio-group v-model="form.hasSemesterGoal">
            <el-radio label="any">不限</el-radio>
            <el-radio label="yes">是</el-radio>
            <el-radio label="no">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-if="form.hasSemesterGoal === 'yes'">
          <template slot="label">
            <span class="required">*</span> 目标进度要求
          </template>
          <div class="semester-progress-row">
            <el-switch
              v-model="form.semesterProgressEnabled"
              active-color="#409eff"
              inactive-color="#dcdfe6"
            />
            <template v-if="form.semesterProgressEnabled">
              <span class="semester-progress-text">完成进度 ≥</span>
              <el-input
                v-model="form.semesterProgressPercent"
                class="semester-progress-input"
                placeholder="0-100"
                maxlength="3"
                @input="onSemesterProgressPercentInput"
              />
              <span class="semester-progress-unit">%</span>
            </template>
          </div>
        </el-form-item>

        <el-form-item>
          <template slot="label">
            <span class="required">*</span> 跑步时段
          </template>
          <div class="running-time-box">
            <div class="running-days">
              <el-checkbox-group v-model="form.weekDays">
                <el-checkbox v-for="d in weekDayOptions" :key="d.value" :label="d.value">
                  {{ d.label }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="running-time-type-row">
              <el-radio-group v-model="form.runningTimeType">
                <el-radio label="allDay">全天</el-radio>
                <el-radio label="range">指定时段</el-radio>
              </el-radio-group>
              <div v-if="form.runningTimeType === 'range'" class="running-time-range">
                <el-select v-model="form.timeStartHour" placeholder="时" class="time-part-select">
                  <el-option
                    v-for="item in hourOptions"
                    :key="'start-hour-' + item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <span class="time-label">时</span>
                <el-select v-model="form.timeStartMinute" placeholder="分" class="time-part-select">
                  <el-option
                    v-for="item in minuteOptions"
                    :key="'start-minute-' + item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <span class="time-label">分</span>
                <span class="time-sep">-</span>
                <el-select v-model="form.timeEndHour" placeholder="时" class="time-part-select">
                  <el-option
                    v-for="item in hourOptions"
                    :key="'end-hour-' + item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <span class="time-label">时</span>
                <el-select v-model="form.timeEndMinute" placeholder="分" class="time-part-select">
                  <el-option
                    v-for="item in minuteOptions"
                    :key="'end-minute-' + item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <span class="time-label">分</span>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="visibleProxy = false">取消</el-button>
      <el-button type="primary" @click="handleSave">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
const API_SUCCESS = 10000;

const defaultForm = () => ({
  name: "",
  description: "",
  isSchoolRunUser: "yes",
  semesterStarted: "any",
  hasSemesterGoal: "any",
  semesterProgressEnabled: false,
  semesterProgressPercent: "50",
  weekDays: [1, 2, 3, 4, 5, 6, 7],
  runningTimeType: "allDay",
  /** 全天保存为 00:00~23:59；切到指定时段时可改 */
  timeStartHour: "00",
  timeStartMinute: "00",
  timeEndHour: "23",
  timeEndMinute: "59",
});

/** 与 AdManagementNew.parseRunningTimeConfigLoose 一致，用于回显 */
function parseRunningTimeConfigLoose(str) {
  if (!str || typeof str !== "string") return null;
  const trimmed = str.trim();
  try {
    return JSON.parse(trimmed);
  } catch (e) {
    try {
      let s = trimmed;
      if (!s.startsWith("{")) return null;
      s = s.replace(/([{,]\s*)([a-zA-Z_][a-zA-Z0-9_]*)\s*:/g, '$1"$2":');
      s = s.replace(/:\s*(\d{2}:\d{2})(?=\s*[,}])/g, ':"$1"');
      return JSON.parse(s);
    } catch (e2) {
      return null;
    }
  }
}

function buildHourOptions() {
  const options = [];
  for (let hour = 0; hour < 24; hour += 1) {
    const h = String(hour).padStart(2, "0");
    options.push({ label: h, value: h });
  }
  return options;
}

function buildMinuteOptions() {
  const options = [];
  for (let minute = 0; minute < 60; minute += 1) {
    const m = String(minute).padStart(2, "0");
    options.push({ label: m, value: m });
  }
  return options;
}

function timeToMinutes(val) {
  const s = String(val == null ? "" : val).trim();
  const m = s.match(/^([01]\d|2[0-3]):([0-5]\d)$/);
  if (!m) return NaN;
  return Number(m[1]) * 60 + Number(m[2]);
}

function splitTimeParts(time, fallbackHour, fallbackMinute) {
  const s = String(time == null ? "" : time).trim();
  const m = s.match(/^([01]\d|2[0-3]):([0-5]\d)$/);
  if (!m) return { hour: fallbackHour, minute: fallbackMinute };
  return { hour: m[1], minute: m[2] };
}

function buildTimeString(hour, minute) {
  const h = String(hour == null ? "" : hour).trim();
  const m = String(minute == null ? "" : minute).trim();
  if (!h || !m) return "";
  return `${h}:${m}`;
}

/** 列表/详情 DTO → 表单模型（编辑回显） */
function crowdDtoToForm(d) {
  const f = defaultForm();
  if (!d || typeof d !== "object") return f;

  f.name = (d.crowdName != null ? String(d.crowdName) : "").trim();
  f.description = (d.crowdDesc != null ? String(d.crowdDesc) : "").trim();
  f.isSchoolRunUser = d.isSchoolTaskUser === 1 ? "yes" : "no";

  if (d.isSemesterStarted === 2) f.semesterStarted = "any";
  else if (d.isSemesterStarted === 1) f.semesterStarted = "yes";
  else if (d.isSemesterStarted === 0) f.semesterStarted = "no";

  if (d.hasSemesterGoal === 2) f.hasSemesterGoal = "any";
  else if (d.hasSemesterGoal === 1) f.hasSemesterGoal = "yes";
  else if (d.hasSemesterGoal === 0) f.hasSemesterGoal = "no";

  if (d.hasSemesterGoal === 1) {
    const p = d.semesterGoalProgress != null ? Number(d.semesterGoalProgress) : 0;
    if (!Number.isNaN(p) && p > 0) {
      f.semesterProgressEnabled = true;
      f.semesterProgressPercent = String(Math.min(100, Math.round(p)));
    } else {
      f.semesterProgressEnabled = false;
      f.semesterProgressPercent = "50";
    }
  }

  const o = parseRunningTimeConfigLoose(d.runningTimeConfig);
  if (o && typeof o === "object") {
    if (Array.isArray(o.weekDays) && o.weekDays.length) {
      const wd = o.weekDays.map((x) => Number(x)).filter((n) => n >= 1 && n <= 7);
      if (wd.length) f.weekDays = wd;
    }
    if (o.timeType === 2) {
      const start = splitTimeParts(o.startTime, "07", "00");
      const end = splitTimeParts(o.endTime, "09", "00");
      f.runningTimeType = "range";
      f.timeStartHour = start.hour;
      f.timeStartMinute = start.minute;
      f.timeEndHour = end.hour;
      f.timeEndMinute = end.minute;
    } else {
      f.runningTimeType = "allDay";
      f.timeStartHour = "00";
      f.timeStartMinute = "00";
      f.timeEndHour = "23";
      f.timeEndMinute = "59";
    }
  }
  return f;
}

export default {
  name: "AdAddCrowdDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    existingCrowdNames: {
      type: Array,
      default: () => [],
    },
    /** 编辑时传入后端人群 id；新增不传，请求体不含 id */
    crowdId: {
      type: Number,
      default: null,
    },
    /** 编辑时传入列表接口返回的原始人群对象（含 runningTimeConfig 等），用于回显 */
    initialCrowdDto: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: defaultForm(),
      weekDayOptions: [
        { value: 1, label: "周一" },
        { value: 2, label: "周二" },
        { value: 3, label: "周三" },
        { value: 4, label: "周四" },
        { value: 5, label: "周五" },
        { value: 6, label: "周六" },
        { value: 7, label: "周日" },
      ],
      hourOptions: buildHourOptions(),
      minuteOptions: buildMinuteOptions(),
    };
  },
  computed: {
    visibleProxy: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    isDuplicateName() {
      const name = (this.form.name || "").trim();
      if (!name) return false;
      return (this.existingCrowdNames || []).includes(name);
    },
    dialogTitle() {
      const id = this.crowdId != null ? Number(this.crowdId) : NaN;
      return !Number.isNaN(id) && id > 0 ? "编辑人群" : "新增人群";
    },
  },
  watch: {
    visible(val) {
      if (!val) return;
      if (this.initialCrowdDto && typeof this.initialCrowdDto === "object") {
        this.form = crowdDtoToForm(this.initialCrowdDto);
      } else {
        this.resetForm();
      }
      this.$nextTick(() => {
        if (this.$refs.formRef) this.$refs.formRef.clearValidate();
      });
    },
    "form.hasSemesterGoal"(val) {
      if (val !== "yes") {
        this.form.semesterProgressEnabled = false;
      }
    },
  },
  methods: {
    resetForm() {
      this.form = defaultForm();
      if (this.$refs.formRef) {
        this.$refs.formRef.clearValidate();
      }
    },
    validateName() {},
    onSemesterProgressPercentInput(val) {
      const digits = String(val == null ? "" : val).replace(/\D/g, "");
      if (digits === "") {
        this.form.semesterProgressPercent = "";
        return;
      }
      let n = parseInt(digits, 10);
      if (n > 100) n = 100;
      this.form.semesterProgressPercent = String(n);
    },
    handleDialogClose() {
      this.resetForm();
    },
    buildCrowdSaveBody(crowdId) {
      const isSchool = this.form.isSchoolRunUser === "yes" ? 1 : 0;
      let isSemesterStarted = 2;
      if (this.form.semesterStarted === "yes") isSemesterStarted = 1;
      else if (this.form.semesterStarted === "no") isSemesterStarted = 0;

      /** hasSemesterGoal：是否有校园跑学期目标 */
      let hasSemesterGoal = 2;
      if (this.form.hasSemesterGoal === "yes") hasSemesterGoal = 1;
      else if (this.form.hasSemesterGoal === "no") hasSemesterGoal = 0;

      /** semesterGoalProgress：目标进度要求（%） */
      let semesterGoalProgress = 0;
      if (hasSemesterGoal === 1 && this.form.semesterProgressEnabled) {
        const p = parseInt(this.form.semesterProgressPercent, 10);
        semesterGoalProgress = Number.isNaN(p) ? 0 : p;
      }

      const timeType = this.form.runningTimeType === "allDay" ? 1 : 2;
      let startTime = buildTimeString(this.form.timeStartHour, this.form.timeStartMinute);
      let endTime = buildTimeString(this.form.timeEndHour, this.form.timeEndMinute);
      /** 全天：未改时段时固定传 00:00 ~ 23:59 */
      if (timeType === 1) {
        startTime = "00:00";
        endTime = "23:59";
      }
      const runningTimeConfig = JSON.stringify({
        weekDays: this.form.weekDays || [],
        timeType,
        startTime,
        endTime,
      });

      const body = {
        crowdName: (this.form.name || "").trim(),
        crowdDesc: (this.form.description || "").trim(),
        isSchoolTaskUser: isSchool,
        isSemesterStarted,
        hasSemesterGoal,
        semesterGoalProgress,
        runningTimeConfig,
        status: 1,
        operator: 0,
      };
      const idForSave = crowdId != null ? crowdId : this.crowdId;
      const idNum = idForSave != null ? Number(idForSave) : NaN;
      if (!Number.isNaN(idNum) && idNum > 0) {
        body.id = idNum;
      }
      return body;
    },
    handleSave() {
      const name = (this.form.name || "").trim();
      if (!name) {
        return this.$message.warning("请输入人群名称");
      }
      if (this.isDuplicateName) {
        return this.$message.warning("人群名称不允许重复");
      }
      const desc = (this.form.description || "").trim();
      if (!desc) {
        return this.$message.warning("请输入人群说明");
      }
      if (this.form.hasSemesterGoal === "yes" && this.form.semesterProgressEnabled) {
        const p = parseInt(this.form.semesterProgressPercent, 10);
        if (Number.isNaN(p) || p < 0 || p > 100) {
          return this.$message.warning("学期目标进度请输入 0～100 的整数");
        }
      }
      if (!this.form.weekDays || this.form.weekDays.length === 0) {
        return this.$message.warning("请至少选择一天跑步时段");
      }
      if (this.form.runningTimeType === "range") {
        if (
          !(this.form.timeStartHour || "").trim() ||
          !(this.form.timeStartMinute || "").trim() ||
          !(this.form.timeEndHour || "").trim() ||
          !(this.form.timeEndMinute || "").trim()
        ) {
          return this.$message.warning("请选择指定时段");
        }
        const startTime = buildTimeString(this.form.timeStartHour, this.form.timeStartMinute);
        const endTime = buildTimeString(this.form.timeEndHour, this.form.timeEndMinute);
        const startMinutes = timeToMinutes(startTime);
        const endMinutes = timeToMinutes(endTime);
        if (Number.isNaN(startMinutes) || Number.isNaN(endMinutes) || startMinutes >= endMinutes) {
          return this.$message.warning("指定时段需满足开始时间早于结束时间");
        }
      }
      const body = this.buildCrowdSaveBody();
      // 与 AdAddStrategyDialog.handleSaveAddStrategy、AdManagementNew 内 crowd/strategy 接口写法一致
      this.$http({
        url: this.$util.domain + "/adminapi/v1/ad/crowd/save",
        method: "POST",
        dataType: "json",
        body: JSON.stringify(body),
      })
        .then((res) => {
          if (res.body.error !== API_SUCCESS) {
            this.$message({
              type: "error",
              message: res.body.message || "保存失败",
            });
            return;
          }
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.$emit("saved");
          this.visibleProxy = false;
        })
        .catch(() => {
          this.$message({
            type: "error",
            message: "操作失败，请稍后再试!",
          });
        });
    },
  },
};
</script>

<style scoped>
.crowd-dialog-body {
  padding: 4px 0 0;
}

.crowd-dialog-form {
  padding: 0 8px;
}

.required {
  color: #f56c6c;
  font-weight: 600;
  margin-right: 4px;
}

.crowd-field-block {
  width: 100%;
}

.crowd-field-error {
  color: #f56c6c;
  font-size: 12px;
  margin-top: 6px;
}

.crowd-hint {
  font-size: 12px;
  line-height: 1.5;
  margin-top: 8px;
}

.crowd-hint--red {
  color: #f56c6c;
}

.semester-progress-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.semester-progress-text {
  font-size: 13px;
  color: #606266;
  margin-left: 4px;
}

.semester-progress-input {
  width: 88px;
}

.semester-progress-input >>> .el-input__inner {
  text-align: left;
}

.semester-progress-unit {
  font-size: 13px;
  color: #606266;
}

.running-time-box {
  width: 100%;
  padding: 14px 16px;
  background-color: #f5f7fa;
  border-radius: 4px;
  box-sizing: border-box;
}

.running-days {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 14px;
  margin-bottom: 14px;
}

.running-time-type-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.running-time-range {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.time-part-select {
  width: 72px;
}

.time-label {
  color: #606266;
  font-size: 12px;
}

.time-sep {
  color: #909399;
}
</style>



// WEBPACK FOOTER //
// AdAddCrowdDialog.vue?4599e68c